import { coreActions } from '@sonar-software/sonar-core';
import { DetailSubsection } from '../DetailSubsection';
import React from 'react';
import { TextEditor } from '../editor';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAction, useSonarObjectReference } from '@hooks';
export const BusinessContextNotes = ({ sonarObjectId }) => {
    var _a, _b, _c;
    const notes = (_c = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.notes) !== null && _c !== void 0 ? _c : '';
    const updateSonarObjectContext = useAction(coreActions.requestPatchCoreSonarObjectsContext);
    const handleSave = (content) => {
        updateSonarObjectContext({
            context: { notes: content },
            sonarObjectId
        });
    };
    return (React.createElement(DetailSubsection, { title: COPY_SPECIFIC.NOTES },
        React.createElement(TextEditor, { canBeEmpty: true, content: notes !== null && notes !== void 0 ? notes : '', onSave: handleSave, placeholder: PLACEHOLDERS_COPY.ADD_ADDITIONAL_NOTES })));
};
